// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopExternalCardControllerGetCustomerExternalCardsData } from './EshopExternalCardControllerGetCustomerExternalCardsData.gen';
import type { EshopExternalCardControllerGetCustomerExternalCardsErrors } from './EshopExternalCardControllerGetCustomerExternalCardsErrors.gen';
import type { EshopExternalCardControllerGetCustomerExternalCardsResponses } from './EshopExternalCardControllerGetCustomerExternalCardsResponses.gen';
import type { Options } from './Options.gen';

export class EshopExternalCardController {
    /**
     * Get external card info list for the given customer.
     */
    public static getCustomerExternalCards<ThrowOnError extends boolean = false>(options: Options<EshopExternalCardControllerGetCustomerExternalCardsData, ThrowOnError>) {
        return (options.client ?? client).get<EshopExternalCardControllerGetCustomerExternalCardsResponses, EshopExternalCardControllerGetCustomerExternalCardsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/external-card/{customerId}',
            ...options
        });
    }
}
